const yup = require("yup");

// Schema for createcollegerules
const creatPageGroup = yup.object({
  icon: yup.string().required("Icon is required"),
  name: yup.string().required("Name is required"),
});

module.exports = {
  creatPageGroup,
};
